import ansis from 'ansis';
import { SeverityLevels } from '../../../types/SeverityLevels';
import { stringifyObject } from '../../stringifyObject';
const NEWLINE_CHAR = '\r\n';
// @ts-expect-error -- this won't fail anything, but will be defined when on edge
const isInEdgeRuntime = typeof EdgeRuntime === 'string';
const isInNodeRuntime = !isInEdgeRuntime && typeof window === 'undefined';
const levelToColoretteFunctionName = {
  [SeverityLevels.INFO]: ansis.blue,
  [SeverityLevels.METRIC]: ansis.green,
  [SeverityLevels.ERROR]: ansis.red,
  [SeverityLevels.WARN]: ansis.yellow,
  [SeverityLevels.DEBUG]: ansis.gray.bgWhite
};
const formatTime = time => new Intl.DateTimeFormat(undefined, {
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  fractionalSecondDigits: 3,
  hour12: false
}).format(new Date(time));
const logLevelToLabel = Object.fromEntries(Object.entries(SeverityLevels));
export const consoleTransportHandler = ({
  time,
  msg,
  level,
  ...properties
}) => {
  const formattedTime = `[${formatTime(time)}]`;
  const userMessage = 'error' in properties && properties.error instanceof Error ? properties.error.message : msg;
  let logLinePrefix = `${formattedTime} (${logLevelToLabel[level]}):`;
  if (isInEdgeRuntime || isInNodeRuntime) {
    logLinePrefix = levelToColoretteFunctionName[level](logLinePrefix);
  }
  let logLine = `${logLinePrefix} ${userMessage}`;
  if (Object.keys(properties).length) {
    logLine += NEWLINE_CHAR;
    if (isInEdgeRuntime || isInNodeRuntime) {
      logLine += stringifyObject(properties);
    }
  }
  const logParams = [logLine];

  // In browser we want to leverage native object searching
  // which is better than printing object itself
  if (!isInEdgeRuntime && !isInNodeRuntime) {
    logParams.push(properties);
  }

  // eslint-disable-next-line no-console -- this is okay
  console.log(...logParams);
};
//# sourceMappingURL=consoleTransportHandler.js.map